import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import { Notifications } from '../common/notification';
import { Account_Update } from '../../config/rest_endpoints'
import Switch from "react-switch";
import axios from 'axios'
import Select from 'react-select'

class EditAccount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            accountName: '',
            accountEmail: '',
            rateUpdateEmail: '',
            billingEmail: '',
            location: '',
            session: '',
            cps: '',
            msg: '',
            accountType: '',
            creditLimit: '',
            switched: true,
            suspend: false,
            selectAccountLCRType:'',
            maxRate: '',
            localANIASRBlockValue:'',
            minimumProfit: '',
            password: '',
            isEye: true,
            limitSwitch:false,
            selectAccountStatus: '',
            optionAccountLCRType:[
                { value: 'system', label: 'True-LCR' },
                { value: 'system-callhold', label: 'LCR Considering Carrier Holdtime' }
            ],
            optionAccountStatus: [
                { value: 'Credit Hold', label: 'Credit Hold' },
                { value: 'Enabled', label: 'Enabled' },
                { value: 'Disabled', label: 'Disabled' }
            ],
            isLoad:false,
            credit: '',
            cName:'callerID',
            inboundCustomerId: 0,
            stirLevel:{ value: 'Do-not-Change', label: 'Do-not-Change' },
            optionStir: [
                { value: 'Do-not-Change', label: 'Do-not-Change' },
                { value: 'A', label: 'A' },
                { value: 'B', label: 'B' },
                { value: 'C', label: 'C' },

            ],
            invoiceLevel:{ value: 'Weekly', label: 'Weekly' },
            optionInvoice: [
                { value: 'Weekly', label: 'Weekly' },
                { value: 'Monthly', label: 'Monthly' },
            ],   

            tnsAsrValue:{ value: 'Off', label: 'Off' },
            optiontnsAsrValue: [
                { value: '-1', label: '-1' },
                { value: '-2', label: '-2' },
                { value: '-3', label: '-3' },
                { value: '-4', label: '-4' },
                { value: 'Off', label: 'Off' },
            ],
        }

        this.handleChange = this.handleChange.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.toggleSwitchSuspend = this.toggleSwitchSuspend.bind(this)
        this.onShowPassword = this.onShowPassword.bind(this)
        this.toggleLimitSwitch = this.toggleLimitSwitch.bind(this)
        this.handleSelectStatus = this.handleSelectStatus.bind(this)
        this.handleSelectAccountLCRType = this.handleSelectAccountLCRType.bind(this)
        this.handleSelectStir = this.handleSelectStir.bind(this)
        this.handleSelecttnsAsrValue = this.handleSelecttnsAsrValue.bind(this)
        this.handleSelectInvoice= this.handleSelectInvoice.bind(this)

    }

    componentWillReceiveProps(newProps) {
        console.log('test111',newProps.previousData)
        this.setState({
            accountName: newProps.previousData.accountName,
            accountEmail: newProps.previousData.accountEmail,
            rateUpdateEmail: newProps.previousData.rateUpdateEmail,
            billingEmail: newProps.previousData.billingEmail,
            location: newProps.previousData.location,
            session: newProps.previousData.sessions,
            cps: newProps.previousData['cps'],
            password: newProps.previousData.password,
            accountType: newProps.previousData.accountType,
            selectAccountLCRType:{ value: newProps.previousData.accountLCRType, label:newProps.previousData.accountLCRType == 'system' ? newProps.previousData.accountLCRType.replace("system", "True-LCR"):"LCR Considering Carrier Holdtime" },
            creditLimit: newProps.previousData.creditLimit,
            suspend:newProps.previousData.suspend,
            switched:newProps.previousData.active,
            limitSwitch:newProps.previousData.disableACTAfterLIM,
            cName: newProps.previousData.cname,
            selectAccountStatus:{ value: newProps.previousData.status, label:newProps.previousData.status == 'Credit Hold' ? newProps.previousData.status.replace("Credit Hold", "Credit Hold"):newProps.previousData.status },
            profitMarkup: newProps.previousData.profitMarkup,
            maxRate : newProps.previousData.maxRate,
            stirLevel:{ value: newProps.previousData.stirShakenLevel, label: newProps.previousData.stirShakenLevel },
            invoice:{ value: newProps.previousData.invoice, label: newProps.previousData.invoice },
            tnsAsrValue: { 
                value: !newProps.previousData.tnsANIBlockValue ? "Off" : newProps.previousData.tnsANIBlockValue, 
                label: !newProps.previousData.tnsANIBlockValue ? "Off" : newProps.previousData.tnsANIBlockValue
              },
            minimumProfit: newProps.previousData.minimumProfit,
            localANIASRBlockValue: newProps.previousData.localANIASRBlockValue,

        })
    }

    handleSelectStir(stirLevel) {
        this.setState({ stirLevel})
    }

    handleSelectInvoice(invoiceLevel) {
        this.setState({ invoiceLevel})
    }  

    handleSelecttnsAsrValue(tnsAsrValue) {
        this.setState({ tnsAsrValue})
    }  

    handleSelectStatus(selectAccountStatus) {
        this.setState({ selectAccountStatus });
        console.log(`selectAccountStatus:`, selectAccountStatus);
    };

    handleSelectAccountLCRType(selectAccountLCRType) {
        this.setState({ selectAccountLCRType });
        console.log(`AccountLCRType:`, selectAccountLCRType);
    };


    toggleLimitSwitch() {
        this.setState({ limitSwitch: !this.state.limitSwitch })
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    toggleSwitchSuspend() {
        this.setState({ suspend: !this.state.suspend })
    }

    onShowPassword() {
        this.setState({ isEye: !this.state.isEye })
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
        })
    }

    onSubmitChange() {
        const { previousData, } = this.props
        const { stirLevel } = this.state
        const { invoiceLevel } = this.state
        const { tnsAsrValue } = this.state
        const accountEdit = {
            'accountName': this.state.accountName,
            'accountEmail': this.state.accountEmail,
            'rateUpdateEmail': this.state.rateUpdateEmail,
            'billingEmail': this.state.billingEmail,
            'location': this.state.location,
            'sessions': parseInt(this.state.session),
            'cps': parseInt(this.state.cps),
            "accountType": this.state.accountType,
            "accountLCRType": this.state.selectAccountLCRType.value,
            "creditLimit": parseFloat(this.state.creditLimit),
            "maxRate": parseFloat(this.state.maxRate),
            "profitMarkup": parseFloat(this.state.profitMarkup),
            'active': this.state.switched,
            'suspend': this.state.suspend,
            'password': this.state.password,
            'disableACTAfterLIM':this.state.limitSwitch,
            'status':this.state.selectAccountStatus.value,
            "stirShakenLevel":stirLevel.value,
            "invoice":invoiceLevel.value,
            'minimumProfit': parseFloat(this.state.minimumProfit),
            'inboundCustomerID': parseInt(this.state.inboundCustomerId),
            'localANIASRBlockValue':parseFloat(this.state.localANIASRBlockValue),
            "tnsANIBlockValue":parseInt(tnsAsrValue.value),
        };
        console.log('accountEdit', accountEdit)
        this.setState({isLoad:true})
        var headers = { 'Authorization': "Bearer " + this.state.User.token }
        axios.put(`${Account_Update}/${previousData.id}/update`, accountEdit, { headers }).then(res => {
            if (res) {
                console.log('res', res)
                this.setState({
                    msg: res.data.message,
                    isLoad:false
                })
                this.props.close()
                this.props.classListing()
                Notifications.notify(this.state.msg, "Created", "success")
            }
            else {
                Notifications.notify("failed Account Created", "Failed", "errors")
            }
        }).catch(err=>{
            this.setState({isLoad:false})
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            Notifications.notify(msessage, "Failed", "error")
        })
    }

    render() {
        const { accountName, accountEmail, rateUpdateEmail, billingEmail, location, session, cps, password, profitMarkup, isEye,creditLimit,cName, maxRate , minimumProfit, localANIASRBlockValue} = this.state
        return (
            <div>
                <fieldset>
                    <legend class="font-weight-semibold fs-16"> Account information</legend>
                    {/* <i class="icon-reading mr-2"></i> */}
                </fieldset>
                <div className='row'>
                <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Account Name</label>
                            <input type="text" className="form-control" name="accountName" value={accountName} onChange={this.handleChange} placeholder="Enter account name" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Account Email</label>
                            <input type="email" className="form-control" name="accountEmail" value={accountEmail} onChange={this.handleChange} placeholder="Enter account email" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group ">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} className="fs-14" >Account Status</label>
                            <Select
                                value={this.state.selectAccountStatus}
                                onChange={this.handleSelectStatus}
                                options={this.state.optionAccountStatus}
                            />   
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Address</label>
                            <input type="text" className="form-control" name="location" value={location} onChange={this.handleChange} placeholder="Enter account address" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} >Password</label>
                            <div class="input-group">
                                <input type={isEye ? "password" : "text"} className="form-control" name="password" value={password} onChange={this.handleChange} placeholder="Enter passowrd" />
                                <span class="input-group-append">
                                    <span class="input-group-text-darker"><i class="icon-eye " onClick={this.onShowPassword}></i></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* row 1 */}
                <fieldset>
                    <legend class="font-weight-semibold  fs-16"> Billing</legend>
                </fieldset>
                <div className='row'>
                <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Billing Email (For Invoice)</label>
                            <input type="email" className="form-control" name="billingEmail" value={billingEmail} onChange={this.handleChange} placeholder="Billing Email"/>
                        </div>
                    </div>
                </div>
                {/* row 2 */}
                <div className='row'>
                <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Rate Update Email</label>
                            <input type="email" className="form-control" name="rateUpdateEmail" value={rateUpdateEmail} onChange={this.handleChange} placeholder="i.e. rates@xyzcompany.com" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Credit Limit</label>
                            <input type="number" className="form-control" name="creditLimit" value={creditLimit} onChange={this.handleChange} placeholder="Enter credit limit" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} className="fs-14" >Invoice Period </label>
                            <Select
                                value={this.state.invoiceLevel}
                                onChange={this.handleSelectInvoice}
                                options={this.state.optionInvoice}
                            />
                        </div>
                    </div>
                </div>
                {/* row 2" */}
                <fieldset>
                    <legend class="font-weight-semibold  fs-16">Settings</legend>
                </fieldset>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.handleChange} placeholder="Enter session" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}}>Session</label>
                            <input type="number" className="form-control" name="session" value={session} onChange={this.handleChange} placeholder="Enter session" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group ">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} className="fs-14" >Account LCR Type</label>
                            <Select
                                value={this.state.selectAccountLCRType}
                                onChange={this.handleSelectAccountLCRType}
                                options={this.state.optionAccountLCRType}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                         <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} className="fs-14" >Stir Shaken Level </label>
                            <Select
                                value={this.state.stirLevel}
                                onChange={this.handleSelectStir}
                                options={this.state.optionStir}
                            />
                        </div>
                    </div>
                </div>
                {/* row 3 */}
                <fieldset>
                    <legend class="font-weight-semibold  fs-16"> Monitory</legend>
                </fieldset>
                <div className='row'>
                <div className="col-md-4 ">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} >Minimum Profit</label>
                            <input type="number" className="form-control" name="minimumProfit" value={minimumProfit} onChange={this.handleChange} placeholder="Enter Minimum Profit" required />
                        </div>
                    </div>
                    <div className="col-md-4 ">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} >Max Rate</label>
                            <input type="number" className="form-control" name="maxRate" value={maxRate} onChange={this.handleChange} placeholder="Enter Mxx Rate" required />
                        </div>
                    </div>
                    <div className="col-md-4 ">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} >Profit Markup</label>
                            <input type="number" className="form-control" name="profitMarkup" value={profitMarkup} onChange={this.handleChange} placeholder="Enter Profit Markup" required />
                        </div>
                    </div>
                </div>
                {/* row 4 */}
                <fieldset>
                    <legend class="font-weight-semibold  fs-16"> Ani ASR Settings</legend>
                </fieldset>
                <div className='row'>
                <div className="col-md-4 ">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} >Local ASR Value</label>
                            <input type="number" className="form-control" name="localANIASRBlockValue" value={localANIASRBlockValue} onChange={this.handleChange} placeholder="Enter Local ASR Value" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label  style={{fontWeight:'400',fontSize:'14px'}} className="fs-14" >TNS ASR Value </label>
                            <Select
                                value={this.state.tnsAsrValue}
                                onChange={this.handleSelecttnsAsrValue}
                                options={this.state.optiontnsAsrValue}
                            />
                        </div>
                    </div>
                </div>
                {/* row 5 */}
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                        <label  style={{fontWeight:'400',fontSize:'14px'}} class="custom-control  custom-checkbox mt-4">
                            <input type="checkbox" class="custom-control-input" style={{ color: '-internal-light-dark(black, white)'}} onChange={this.toggleLimitSwitch} checked={this.state.limitSwitch} />
                            <span class="custom-control-label">Enforce Credit Limit</span>
                        </label>
                            {/* <label className="fs-14">Credit Limit </label>
                            <div className="side-left">
                                <Switch onChange={this.toggleLimitSwitch} checked={this.state.limitSwitch} />
                            </div> */}
                            <small id="emailHelp" class="form-text text-muted fs-14">This Enforces Credit limit(no calls upon credit limit) on the account</small>
                        </div>
                    </div>
                    {/* <div className="col-md-4">
                        <div className="form-group">
                            <label className="fs-14">Credit Limit </label>
                            <div className="side-left">
                                <Switch onChange={this.toggleLimitSwitch} checked={this.state.limitSwitch} />
                            </div>
                            <small id="emailHelp" class="form-text text-muted fs-14">Inactive after credit limit</small>
                        </div>
                    </div> */}
                </div>
                <div className="row" style={{borderTop:'1px solid #e9ecef'}}>
                    <div className="col-md-6 ml-auto">
                        <button type="submit " className="main-button mt-2 btn btn-primary btn-sm float-right" onClick={this.onSubmitChange} > Update Account <i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " :"icon-pencil5 ml-1 icon-1x"}></i></button>
                    </div>
                </div>
            </div>
        )
    }
}
export default EditAccount